import { defineStore } from 'pinia';
import { ref } from 'vue';

import { trackSearchOpen, type SearchOpenSource } from '#/lib/analytics';

/**
 * 통합 검색(078) 패널 상태 — 진입점 2(히어로 검색창·GNB 런처/⌘K) ↔ 패널 1(셸 1회 마운트)을 잇는 최소 스토어(R7).
 *
 * 진입점은 `open(source, q?)` 만 호출한다. 패널은 셸(레이아웃)에, 히어로는 라우트 컴포넌트에 있어
 * props/provide 로는 이을 수 없다. 상태는 3필드·3액션으로 묶어 둔다 — 결과·목록은 `useUnifiedSearch` 소유.
 * 열림 플래그는 액션 이름과 겹치지 않게 `isOpen` 으로 둔다.
 */
export const useUnifiedSearchStore = defineStore('unifiedSearch', () => {
  const isOpen = ref(false);
  const source = ref<SearchOpenSource | null>(null);
  const query = ref('');

  /** 패널 열기 — 닫힘→열림 전이에서만 GA4 `search_open` 발화(이미 열린 상태의 칩 클릭은 미발화). */
  function open(from: SearchOpenSource, initialQuery?: string): void {
    if (initialQuery !== undefined) query.value = initialQuery;
    if (isOpen.value) return;
    source.value = from;
    isOpen.value = true;
    trackSearchOpen(from);
  }

  function close(): void {
    isOpen.value = false;
    source.value = null;
  }

  function setQuery(q: string): void {
    query.value = q;
  }

  return { isOpen, source, query, open, close, setQuery };
});
